module.exports = __webpack_public_path__ + "static/media/grass_dark.151b9883.jpg";